<template>
  <div>
    <div class="graphic">
      <four-mat-chart :data="assessment"></four-mat-chart>
    </div>
    <div class="visible-message" v-if="!isMember() && !assessment.visible">
      This data is hidden from the mentee. Edit results to make visible.
    </div>
    <v-btn
      v-if="!isMember()"
      class="ma-4 js-updaters-toggle-button"
      small
      fab
      dark
      color="secondary"
      @click="showUpdater = !showUpdater"
    >
      <v-icon dark>mdi-pencil</v-icon>
    </v-btn>

    <v-sheet elevation="1" class="pa-1" v-if="showUpdater">
      <four-mat-add
        :userId="userId"
        :v1="assessment.q1"
        :v2="assessment.q2"
        :v3="assessment.q3"
        :v4="assessment.q4"
        :quadrantPrimary="assessment.quadrant"
        :visible="assessment.visible"
      ></four-mat-add>
    </v-sheet>
    <div>
      <four-mat-text1 v-if="assessment.quadrant == 1"></four-mat-text1>
      <four-mat-text2 v-if="assessment.quadrant == 2"></four-mat-text2>
      <four-mat-text3 v-if="assessment.quadrant == 3"></four-mat-text3>
      <four-mat-text4 v-if="assessment.quadrant == 4"></four-mat-text4>
    </div>
  </div>
</template>

<script>
import titleMixin from "@/mixins/titleMixin"
import eventMixin from "@/mixins/eventMixin"
import userMixin from "@/mixins/userMixin"
import FourMatChart from "@/components/assessments/FourMatChart"
import FourMatAdd from "@/components/assessments/FourMatAdd"
import FourMatText1 from "@/components/assessments/FourMatText1"
import FourMatText2 from "@/components/assessments/FourMatText2"
import FourMatText3 from "@/components/assessments/FourMatText3"
import FourMatText4 from "@/components/assessments/FourMatText4"

import User from "@/lib/user"
import { mapGetters } from "vuex"
import { AssessmentsAPI } from "@/lib/api"

export default {
  mixins: [titleMixin, eventMixin, userMixin],
  components: {
    FourMatChart,
    FourMatAdd,
    FourMatText1,
    FourMatText2,
    FourMatText3,
    FourMatText4
  },
  data: function() {
    return {
      title: "Learning Style",
      userId: this.$route.params.id,
      userType: User.getUserType(),
      assessment: {},
      showUpdater: false
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id) {
      this.userId = to.params.id

      this.$store
        .dispatch("assessments/assessmentsByUserId", {
          userId: this.userId
        })
        .then(() => {
          this.assessment = this.getAssessmentByType("4-Mat") || {}
        })
    }
    next()
  },
  created() {
    this.assessment = this.getAssessmentByType("4-Mat") || {}

    // listener for add 4-Mat (we always want to display this assessment as 4MAT, but it is in the store as 4-Mat)
    this.addListener(
      "four_mat_result:add",
      ({ userId, q1, q2, q3, q4, quadrant, visible }) => {
        AssessmentsAPI.add4Mat(userId, q1, q2, q3, q4, quadrant, visible).then(
          () => {
            this.$store
              .dispatch("assessments/assessmentsByUserId", {
                userId: this.userId
              })
              .then(() => {
                this.assessment = this.getAssessmentByType("4-Mat")
              })
          }
        )
      }
    )
  },
  methods: {
    getAssessmentByType(type) {
      return this.assessments
        ? this.assessments.find(el => el.type == type)
        : {}
    }
  },
  computed: {
    ...mapGetters("assessments", ["getAssessmentsByUserId"]),
    assessments() {
      if (this.getAssessmentsByUserId(this.userId)) {
        return this.getAssessmentsByUserId(this.userId).assessments
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";

.graphic {
  width: 100%;
  margin: 0px auto;
  max-width: 600px;
}

.visible-message {
  color: $white;
  background-color: $orange;
  border-radius: 5px;
  font-size: 2em;
  padding: 5px;
  text-align: center;
  width: 100%;
  margin-bottom: 10px;
  @media (max-width: 1200px) {
    font-size: 1.2em;
  }
}
</style>
